import '@hapana/shared/utils/type-defs.util'

/** @type {Styles} */
export const styles = {
  search: () => ({
    '.MuiOutlinedInput-root': {
      paddingX: 3.5,
      paddingY: 0.5,
      typography: 'medium',
    },
    '.MuiOutlinedInput-root > .MuiOutlinedInput-notchedOutline': {
      border: 0,
    },
  }),
  searchIcon: {
    fontSize: 16,
    marginRight: 1.5,
    color: 'gray.40',
  },
  thickDivider: {
    backgroundColor: 'gray.3',
    height: 8,
    border: 0,
    borderTop: (theme) => `1px solid ${theme.palette.gray[8]}`,
  },
  clearSearchIcon: {
    marginRight: 1,
    ':hover': {
      border: 'none',
      backgroundColor: '#gray.0',
    },
    ':focus': {
      border: 'none',
      backgroundColor: '#gray.0',
    },
  },
}
